export default __webpack_public_path__ + "static/media/lorem-ipsum-generator-dark.88b0e29f.png";